export default __webpack_public_path__ + "static/media/team-zero.d1ce557d.svg";